import { coins, marketDate } from '../format';
import { useState } from 'react';
import { EmptyState } from '@/components/ui/EmptyState';
import { useMarketOrders } from '../api';
import { CoinMark, LoadError, Pagination } from './MarketParts';

export function MyOrders() {
  const [page, setPage] = useState(1);
  const orders = useMarketOrders(page);
  return (
    <section id="market-orders" className="market-history" aria-labelledby="market-orders-title">
      <div className="market-section-heading">
        <div>
          <p className="market-eyebrow">SEÇİMLERİNİ TAKİP ET</p>
          <h2 id="market-orders-title">Siparişlerim</h2>
        </div>
      </div>
      {orders.isPending ? (
        <p role="status" className="market-loading">
          Siparişlerin yükleniyor…
        </p>
      ) : orders.isError ? (
        <LoadError
          label="Siparişlerin yüklenemedi."
          retry={() => {
            void orders.refetch();
          }}
        />
      ) : orders.data.rows.length === 0 ? (
        <EmptyState
          title="İlk seçimini yapmaya hazır mısın?"
          description="Market’ten aldığın ürünler ve teslimat durumları burada görünecek."
        />
      ) : (
        <>
          <ul className="market-orders">
            {orders.data.rows.map((order) => (
              <li key={order.id}>
                <div className="market-order-top">
                  {order.productImageUrl ? (
                    <img src={order.productImageUrl} alt="" width={56} height={56} />
                  ) : (
                    <CoinMark small />
                  )}
                  <div>
                    <h3>{order.productTitle}</h3>
                    <time dateTime={order.createdAtUtc}>{marketDate(order.createdAtUtc)}</time>
                  </div>
                  <span className={`market-order-status market-order-${order.status}`}>
                    {order.status === 'fulfilled'
                      ? 'Tamamlandı'
                      : order.status === 'cancelled'
                        ? 'İptal edildi'
                        : 'Hazırlanıyor'}
                  </span>
                </div>
                <div className="market-order-meta">
                  <span>Sipariş #{order.id.slice(-8).toUpperCase()}</span>
                  <strong>{coins(order.coinPrice)} GC</strong>
                </div>
                {order.deliveryDetails ? (
                  <div className="market-order-note">
                    <span>Teslimat bilgilerin</span>
                    <p>{order.deliveryDetails}</p>
                  </div>
                ) : null}
                {order.fulfillmentNote ? (
                  <div className="market-order-note">
                    <span>Ekipten not</span>
                    <p>{order.fulfillmentNote}</p>
                  </div>
                ) : null}
                {order.status === 'cancelled' ? (
                  <p className="market-order-refund">
                    {coins(order.coinPrice)} GC hesabına iade edildi.
                  </p>
                ) : null}
              </li>
            ))}
          </ul>
          <Pagination
            page={orders.data.page}
            pageSize={orders.data.pageSize}
            totalCount={orders.data.totalCount}
            onPage={setPage}
          />
        </>
      )}
    </section>
  );
}
